import { render, staticRenderFns } from "./arguments.vue?vue&type=template&id=339a4500&scoped=true&"
import script from "./arguments.vue?vue&type=script&lang=js&"
export * from "./arguments.vue?vue&type=script&lang=js&"
import style0 from "./arguments.vue?vue&type=style&index=0&id=339a4500&lang=less&scoped=true&"
import style1 from "./arguments.vue?vue&type=style&index=1&id=339a4500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a4500",
  null
  
)

export default component.exports